import axios from "axios";
import { format } from "date-fns";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  saleCardAmount,
  saleCardName,
  saleCash,
  saleDiscount,
  saleMfsAmount,
  saleMfsName,
} from "../../../features/posSlice";
import { useAddPaymentMutation } from "../../../services/paymentApi";
import { signInUser } from "../../Utility/Auth";
import { notify } from "../../Utility/Notify";

const POS3BillGenerate = ({ title, onShow, handleClose,handlePrintBill }) => {
  const posData = useSelector((state) => state.posReducer);
  const dispatch = useDispatch();
  const [discountChecked, setDiscountChecked] = useState(false);

  useEffect(() => {
    if (onShow && posData?.grossTotalRound > 0) {
      const currentNonCash =
        (Number(posData?.paidAmount?.card?.amount) || 0) +
        (Number(posData?.paidAmount?.mfs?.amount) || 0) +
        (Number(posData?.paidAmount?.point) || 0);

      const currentCash = Number(posData?.paidAmount?.cash) || 0;

      if (currentNonCash === 0 || currentCash === 0) {
        dispatch(saleCash(posData.grossTotalRound - currentNonCash));
      }
    }
  }, [onShow, posData?.grossTotalRound, dispatch]);

  useEffect(() => {
    if (onShow) {
      const timer = setTimeout(() => {
        const cashField = document.getElementById("cashAmount");
        if (cashField) {
          cashField.focus();
          cashField.select?.();
        }
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [onShow]);

  const discountCheckbox = () => {
    setDiscountChecked(!discountChecked);
  };
  
  const handleCancel = () => {
    handleClose();
  };

  const totalReceived =
    (Number(posData?.paidAmount?.cash) || 0) +
    (Number(posData?.paidAmount?.card?.amount) || 0) +
    (Number(posData?.paidAmount?.mfs?.amount) || 0) +
    (Number(posData?.paidAmount?.point) || 0);

  const grossTotalRound = Number(posData?.grossTotalRound) || 0;
  const changeAmount =
    totalReceived >= grossTotalRound && grossTotalRound > 0
      ? totalReceived - grossTotalRound
      : Number(posData?.changeAmount) > 0
      ? Number(posData?.changeAmount)
      : 0;

  return (
    <Modal
      size="lg"
      show={onShow}
      onHide={handleClose}
      onEntered={() => {
        const el = document.getElementById("cashAmount");
        el?.focus?.();
        el?.select?.();
      }}
    >
      <Form>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container fluid>
            <div className="card mt-2 p-2">
              <Row className="px-3 py-2">
                {/* Bill Details Section */}
                <Col xs={12} md={6} className="ps-2 gap-2">
                <b>Order Details</b>
                  <hr />
                  <p>
                    <b>Total Item:</b>{" "}
                    <span className="float-end">
                    {posData?.products?.length || 0} 
                    </span>
                    <br />
                    {posData?.returnProducts?.length > 0 && <>
                      <b>Return Item:</b>{" "}
                      <span className="float-end">
                        {posData?.returnProducts?.length || 0} 
                      </span>
                      <br />
                    </>}
                    <b>Total:</b>{" "}
                    <span className="float-end">
                      {posData?.total?.toFixed(2)} TK
                    </span>
                    <br />
                    {posData?.returnProducts?.length > 0 && <>
                      <b>Return Total:</b>{" "}
                      <span className="float-end">
                        {posData?.returnCal.grossTotalRound || 0}  TK
                      </span>
                      <br />
                    </>}
                    <b>Vat:</b>{" "}
                    <span className="float-end">{posData?.vat?.toFixed(2)} TK</span>
                    {posData?.promo_discount > 0 && (
                      <>
                      <br />
                        <b>Promo Discount: </b>{" "}
                        <span className="float-end">
                          {posData?.promo_discount?.toFixed(2)}
                          TK
                        </span>
                        </>
                    )}
                    {posData?.discount > 0 && (
                      <>
                      <br />
                        <b>Discount: </b>{" "}
                        <span className="float-end">
                          {posData?.discount?.toFixed(2)}
                          TK
                        </span>
                        </>
                    )}
                    <br />
                    <b>Gross Total:</b>{" "}
                    <span className="float-end">{posData?.grossTotal?.toFixed(2)} TK</span>
                    <br />
                    <hr/>
                    <b>Gross Total Round:</b>{" "}
                    <span className="float-end">
                      {posData?.grossTotalRound?.toFixed(2) || 0} TK
                    </span>
                  </p>
                </Col>
                <Col xs={12} md={6} className="pe-2 gap-2 border-left">
                  <b>Payment Details</b>
                  <hr />
                  <Row>
                    <Col xs={6}>
                      <b>Cash Received:</b>
                    </Col>
                    <Col xs={6}>
                      <input
                        type="number"
                        onChange={(e) =>
                          dispatch(
                            saleCash(e.target.value > 0 ? e.target.value : 0)
                          )
                        }
                        id="cashAmount"
                        min={0}
                        value={posData.paidAmount.cash}
                        className="form-control"
                      />
                    </Col>
                  </Row>
                  {/* Card Section */}
                  <Row className="mt-2">
                    <Col xs={3}>
                      <b>Card:</b>
                    </Col>
                    <Col xs={5}>
                      <Form.Select
                        id="cardType"
                        onChange={(e) => dispatch(saleCardName(e.target.value))}
                      >
                        <option value="visa">Visa</option>
                        <option value="masterCard">Master Card</option>
                        <option value="MTB">MTB</option>
                        <option value="CITY">CITY</option>
                        <option value="DBBL">DBBL</option>
                        <option value="EBL">EBL</option>
                        <option value="BRAC">BRAC</option>
                      </Form.Select>
                      </Col>
                      <Col xs={4}>
                      <input
                        type="number"
                        id="cardAmount"
                        defaultValue={0}
                        onChange={(e) =>
                          dispatch(
                            saleCardAmount(
                              parseInt(e.target.value > 0 ? e.target.value : 0)
                            )
                          )
                        }
                        min={0}
                        value={posData?.paidAmount?.card?.amount}
                        className="form-control mt-2"
                      />
                    </Col>
                  </Row>
                  {/* MFS Section */}
                  <Row className="mt-2 align-item-center">
                    <Col xs={3} className=" align-item-center">
                      <b>MFS:</b>
                    </Col>
                    <Col xs={5} className=" align-item-center">
                      <Form.Select
                        id="mfsName"
                        onChange={(e) => dispatch(saleMfsName(e.target.value))}
                      >
                        <option value="bKash">Bkash</option>
                        <option value="Nagad">Nagad</option>
                        <option value="Upay">Upay</option>
                        <option value="Rocket">Rocket</option>
                      </Form.Select>
                      </Col>
                      <Col xs={4} className=" align-item-center">
                      <input
                        type="number"
                        id="mfsAmount"
                        defaultValue={0}
                        onChange={(e) =>
                          dispatch(
                            saleMfsAmount(
                              e.target.value > 0 ? e.target.value : 0
                            )
                          )
                        }
                        value={posData.paidAmount.mfs.amount}
                        className="form-control mt-2"
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2 align-item-center">
                    <Col xs={5} className=" align-item-center">
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicCheckbox"
                      >
                        <Form.Check
                          type="checkbox"
                          label="Discount: "
                          onChange={discountCheckbox}
                          checked={discountChecked}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={7} className=" align-item-center">
                      {posData?.group !== null && "10% "}
                        <input
                          disabled={discountChecked === false && "disabled"}
                          type="number"
                          onChange={(e) =>
                            dispatch(
                              saleDiscount(
                                parseInt(e.target.value > 0 ? e.target.value : 0)
                              )
                            )
                          }
                          id="discount"
                          defaultValue={0}
                          min={0}
                          value={Math.round(posData.discount) || "0"}
                          className="form-control float-end"
                        />
                    </Col>
                  </Row>
                  <hr />
                  <p>
                    <b>Total Recieved:</b>{" "}
                    <span className="float-end">
                      {parseFloat(totalReceived || 0).toFixed(2)} TK
                    </span>
                    <br />
                    <b>Change Amount:</b>{" "}
                    <span className="float-end">
                      {parseFloat(changeAmount || 0).toFixed(2)} TK
                    </span>
                    <br />
                    {/* <b>Remaining Due:</b>{" "}
                    <span className="float-end">
                      {invoices?.totalDue || 0  - posData?.dueAmount ||0} TK
                    </span> */}
                  </p>
                  <div className="text-end">
                    <Button
                      variant="dark"
                      id="generateOrderBtn"
                      // disabled={posData?.grossTotalRound <= posData?.grossTotalRound}
                      onClick={()=>handlePrintBill()}
                    >
                      <Icons.CurrencyBangladeshi /> Generate Order
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </Modal.Footer>
      </Form>
      <Toaster position="bottom-right" />
    </Modal>
  );
};

export default POS3BillGenerate;
